import { getLoggedProfile as GetLoggedProfile, logout as Logout } from "../model/profile";


export function getLoggedProfile() {
    return {
        type: "GET_LOGGED_PROFILE",
        payload: GetLoggedProfile()
    }
}

export function logout() {
	return {
		type: "LOG_OUT",
		payload: Logout()
	}
}




// WEBPACK FOOTER //
// ./src/actions/sessionAct.js